// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__Gesr4","error":"Textarea_error__2L7N3","readonly":"Textarea_readonly__3xpS2","disabled":"Textarea_disabled__34PtA"};